import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 获取区域列表
export const getdistrictList = params => {
    return get("/admin/regions", params);
};
// 新增区域
export const addDistrict = params => {
    return post("/admin/regions", params);
};
// 修改区域信息
export const editDistrict = params => {
    return put(`/admin/regions/${params.id}`, params);
};
// 删除区域
export const deleteDistrict = params => {
    return del(`/admin/regions/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/district.js